import apiClient from '../lib/api/client';
import { getApiUrl, buildApiUrl } from '../config/config';
import { extractErrorMessage } from '../utils/errorHandler';

const createErrorResponse = (error, defaultMessage = 'An unexpected error occurred') => {
  const errorMessage = extractErrorMessage(
    error.response?.data || error,
    defaultMessage
  );

  return {
    isSuccess: false,
    data: null,
    error: {
      message: errorMessage,
      code: error.response?.status || 500,
      originalError: error,
    },
  };
};

const alertsAlarmService = {
  async getAlertsAlarmConfig() {
    try {
      const response = await apiClient.get(getApiUrl('AUTH', 'ALERTS_ALARM'));

      if (response.data?.isSuccess) {
        return {
          isSuccess: true,
          data: response.data.data,
          error: null,
        };
      }

      return {
        isSuccess: false,
        data: null,
        error: response.data?.error || { message: 'Failed to fetch alerted conversation alarm configuration' },
      };
    } catch (error) {
      return createErrorResponse(error, 'Failed to fetch alerted conversation alarm configuration');
    }
  },

  async updateAlertsAlarmConfig(configData) {
    try {
      const response = await apiClient.patch(getApiUrl('AUTH', 'ALERTS_ALARM'), configData);

      if (response.data?.isSuccess) {
        return {
          isSuccess: true,
          data: response.data.data,
          error: null,
        };
      }

      return {
        isSuccess: false,
        data: null,
        error: response.data?.error || { message: 'Failed to update alerted conversation alarm configuration' },
      };
    } catch (error) {
      return createErrorResponse(error, 'Failed to update alerted conversation alarm configuration');
    }
  },

  async activateAlertsAlarmConfig() {
    try {
      const response = await apiClient.post(getApiUrl('AUTH', 'ALERTS_ALARM_ACTIVATE'));

      if (response.data?.isSuccess) {
        return {
          isSuccess: true,
          data: response.data.data,
          error: null,
        };
      }

      return {
        isSuccess: false,
        data: null,
        error: response.data?.error || { message: 'Failed to activate alerted conversation alarm' },
      };
    } catch (error) {
      return createErrorResponse(error, 'Failed to activate alerted conversation alarm');
    }
  },

  async deactivateAlertsAlarmConfig() {
    try {
      const response = await apiClient.post(getApiUrl('AUTH', 'ALERTS_ALARM_DEACTIVATE'));

      if (response.data?.isSuccess) {
        return {
          isSuccess: true,
          data: response.data.data,
          error: null,
        };
      }

      return {
        isSuccess: false,
        data: null,
        error: response.data?.error || { message: 'Failed to disable alerted conversation alarm' },
      };
    } catch (error) {
      return createErrorResponse(error, 'Failed to disable alerted conversation alarm');
    }
  },

  async respondToAlertsAlarmCard(conversationId, { cardId, action }) {
    try {
      const url = buildApiUrl(`/api/chats/conversations/${conversationId}/accept/`);
      const response = await apiClient.post(url, {
        card_id: cardId,
        action,
      });

      if (response.data?.isSuccess) {
        return {
          isSuccess: true,
          data: response.data.data,
          error: null,
        };
      }

      return {
        isSuccess: false,
        data: null,
        error: response.data?.error || { message: 'Failed to respond to the alert card' },
      };
    } catch (error) {
      return createErrorResponse(error, 'Failed to respond to the alert card');
    }
  },
};

export default alertsAlarmService;
